import { useMemo } from 'react'
import {
  EntitySearchCellDef,
  SearchOnEntitySearchCell,
  TextCellDef,
} from '../../../../../../containers/SingleSheetV2/table/model'
import { intl } from '../../../../../../../i18n'

export const useTicketList = (
  searchTicketList: SearchOnEntitySearchCell
): EntitySearchCellDef => {
  const cellDef = useMemo<EntitySearchCellDef>(() => {
    return {
      externalId: 'ticketList',
      field: 'ticketList',
      label: intl.formatMessage({ id: 'ticketList' }),
      type: 'ENTITY_SEARCH',
      width: 'half',
      required: true,
      editable: true,
      search: searchTicketList,
      displayIcon: false,
    }
  }, [searchTicketList])
  return cellDef
}
export const useParentWbsItem = (): EntitySearchCellDef => {
  const cellDef = useMemo<EntitySearchCellDef>(() => {
    return {
      externalId: 'parentWbsItem',
      field: 'parentWbsItem',
      label: intl.formatMessage({ id: 'parentWbsItem' }),
      type: 'ENTITY_SEARCH',
      width: 'full',
      required: false,
      editable: false,
      search: async (searchText: string) => {
        return []
      },
      displayIcon: false,
    }
  }, [])
  return cellDef
}

/**
 * @deprecated
 * This property is not shown.
 * Remove this property after replacing SingleSheetV2 completely.
 * To make the form layout(row index) same as old SingleSheet(function_properties).
 * In function_properties "hidden" of this property is true.
 */
export const useTicketType = (): TextCellDef => {
  const cellDef = useMemo<TextCellDef>(() => {
    return {
      externalId: 'ticketType',
      field: 'ticketType',
      label: intl.formatMessage({ id: 'wbsItem.ticketType' }),
      type: 'TEXT',
      width: 'half',
      required: false,
      editable: false,
      hidden: true,
    }
  }, [])
  return cellDef
}
